/**
 * Sandbox SMS previews (SMS shown, not sent). The core API puts them on the
 * X-Nevisign-Sms response header as base64 of UTF-8 JSON, and keeps the ones
 * sent after a response in the /sms/previews feed. Production sets neither.
 *
 * Every client reads them through these helpers so the limits stay the same
 * everywhere (dastyar-modiran's server/src/sandbox-sms.ts `clean()` uses the
 * same ones). marketing and word-addin keep a copy each, held to this one by
 * a parity test.
 */
export const SMS_PREVIEW_HEADER = "X-Nevisign-Sms";
export const SMS_PREVIEW_LIMITS = {
    items: 10,
    phone: 32,
    message: 1000,
    purpose: 64,
};
const SMS_CODE_RE = /^\d{3,10}$/;
/** One preview from untrusted JSON, trimmed to the limits; null if it is not one. */
export function cleanSmsPreview(value) {
    if (!value || typeof value !== "object")
        return null;
    const v = value;
    if (typeof v.phone !== "string" || typeof v.message !== "string")
        return null;
    return {
        phone: v.phone.slice(0, SMS_PREVIEW_LIMITS.phone),
        message: v.message.slice(0, SMS_PREVIEW_LIMITS.message),
        purpose: typeof v.purpose === "string" && v.purpose ? v.purpose.slice(0, SMS_PREVIEW_LIMITS.purpose) : undefined,
        code: typeof v.code === "string" && SMS_CODE_RE.test(v.code) ? v.code : undefined,
    };
}
/** A list of previews (feed rows, header list), at most `SMS_PREVIEW_LIMITS.items`. */
export function cleanSmsPreviewList(list) {
    if (!Array.isArray(list))
        return [];
    const out = [];
    for (const v of list.slice(0, SMS_PREVIEW_LIMITS.items)) {
        const sms = cleanSmsPreview(v);
        if (sms)
            out.push(sms);
    }
    return out;
}
/** Decodes the X-Nevisign-Sms header value. A malformed header gives []. */
export function decodeSmsHeader(raw) {
    if (!raw)
        return [];
    try {
        const g = globalThis;
        const bytes = Uint8Array.from(g.atob(raw), (c) => c.charCodeAt(0));
        return cleanSmsPreviewList(JSON.parse(new g.TextDecoder().decode(bytes)));
    }
    catch {
        return [];
    }
}
